import { render, staticRenderFns } from "./lazyComponent.vue?vue&type=template&id=3adebdcd&scoped=true"
import script from "./lazyComponent.vue?vue&type=script&lang=js"
export * from "./lazyComponent.vue?vue&type=script&lang=js"
import style0 from "./lazyComponent.vue?vue&type=style&index=0&id=3adebdcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adebdcd",
  null
  
)

export default component.exports